import { render, staticRenderFns } from "./hotspot.html?vue&type=template&id=7d8fd25f&scoped=true&"
import script from "./hotspot.js?vue&type=script&lang=js&"
export * from "./hotspot.js?vue&type=script&lang=js&"
import style0 from "./hotspot.scss?vue&type=style&index=0&id=7d8fd25f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8fd25f",
  null
  
)

export default component.exports